import * as React from 'react'
import { memo } from 'react'
const SvgZoom = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M0 14V9.625h.875v2.881l3.15-3.15.619.619-3.15 3.15h2.881V14Zm9.625 0v-.875h2.881l-3.15-3.15.619-.619 3.15 3.15V9.625H14V14Zm-5.6-9.356-3.15-3.15v2.881H0V0h4.375v.875H1.494l3.15 3.15Zm5.95 0-.619-.619 3.15-3.15H9.625V0H14v4.375h-.875V1.494Z" />
  </svg>
)
const Memo = memo(SvgZoom)
export default Memo
